class UpdateStaffMember {
	constructor(
		public readonly organizationId: number,
		public readonly staffMemberId: number,
		public readonly firstName: string,
		public readonly lastName: string,
		// The raw enum value (e.g. `'nursing_staff'`), never the `{ value, label }` object read from the API.
		public readonly jobFunction: string,
		public readonly phoneNumber: string | null,
		public readonly email: string | null,
		public readonly facilityIds: readonly number[],
	) {
		Object.freeze(this);
	}

	// `organizationId` and `staffMemberId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			jobFunction: this.jobFunction,
			phoneNumber: this.phoneNumber,
			email: this.email,
			facilityIds: this.facilityIds,
		};
	}
}

export default UpdateStaffMember;
